import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users, UtensilsCrossed, MapPin, FileText, Award, TrendingUp } from "lucide-react";

const StatCard = ({ label, value, icon: Icon, sub }) => (
  <Card className="bg-card border-border">
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="text-sm text-muted-foreground">{label}</p>
          <p className="text-3xl font-bold text-primary">{value}</p>
        </div>
        <Icon className="w-8 h-8 text-primary/50" />
      </div>
      {sub && <p className="text-xs text-green-400 mt-2">{sub}</p>}
    </CardContent>
  </Card>
);

const OverviewTab = ({ stats }) => {
  if (!stats) return null;
  return (
    <div className="space-y-8">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <StatCard label="Total Users" value={stats.overview.total_users} icon={Users} sub={`+${stats.overview.recent_signups_7d} this week`} />
        <StatCard label="Restaurants" value={stats.overview.total_restaurants} icon={UtensilsCrossed} />
        <StatCard label="Total Visits" value={stats.overview.total_visits} icon={MapPin} />
        <StatCard label="Reviews" value={stats.overview.total_reviews} icon={FileText} />
      </div>

      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Award className="w-5 h-5 text-primary" />
            Badge Distribution
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {Object.entries(stats.badge_distribution).map(([badge, count]) => (
              <div key={badge} className="text-center p-4 bg-muted/20 rounded-lg">
                <p className="text-2xl font-bold text-primary">{count}</p>
                <p className="text-xs text-muted-foreground">{badge}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card className="bg-card border-border">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <TrendingUp className="w-5 h-5 text-primary" />
            Top Restaurants by Visits
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-2">
            {stats.top_restaurants.map((rest, idx) => (
              <div key={rest._id} className="flex items-center justify-between p-3 bg-muted/20 rounded">
                <div className="flex items-center gap-3">
                  <span className="text-primary font-bold">#{idx + 1}</span>
                  <span>{rest.name}</span>
                </div>
                <span className="text-muted-foreground">{rest.visit_count} visits</span>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewTab;
